module.exports = require('./Ellipse').Circle;